import axios from 'axios';

import { logError } from '../../infrastructure/error-handling.js';

class PartnerWithUsService {
	getData(language) {
		return axios
			.get(
				`${
					process.env.REACT_APP_API_ENDPOINT
				}/api/singletons/get/partnerWithUs?lang=${language}`,
			)
			.then(res => res.data)
			.catch(logError);
	}
}

export default new PartnerWithUsService();
